import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Clipboard from 'clipboard';
import Prism from 'prismjs';
import 'prismjs/plugins/normalize-whitespace/prism-normalize-whitespace';
import 'prismjs/plugins/line-numbers/prism-line-numbers';
import Dropdown, { DropdownItem } from '../common/Dropdown';
import Button from '../common/Button';
import BulbIcon from '../../assets/icons/lightbulb.svg';

export default class Snippets extends Component {
    constructor() {
        super();
        this.state = {
            selected: 'html',
        };
    }

    componentDidUpdate(prevProps) {
        const nextProps = this.props;
        if (prevProps.snippets && nextProps.snippets && prevProps.snippets.code !== nextProps.snippets.code) {
            Prism.highlightAll();
            new Clipboard('.clipboard-btn');
        }
    }

    componentDidMount() {
        Prism.highlightAll();
        new Clipboard('.clipboard-btn');
        window.addEventListener("resize", this.onResize);
        this.onResize();
    }

    onResize = () => {
        this.setState({hideTabs: window.innerWidth <= 1080});
    }

    _getCustomScriptSource = () => {
        const script = this.props.snippets.commonScriptsCode.find(script => script.name === this.state.selected);
        return script.code;
    }

    _getCustomScriptName = () => {
        const script = this.props.snippets.commonScriptsCode.find(script => script.name === this.state.selected);
        return script.name;
    }

    _onClick = (selectedScript) => {
        this.setState({
            selected: selectedScript
        }, () => Prism.highlightAll());
    }

    _renderScriptMenuItem = () => {
        const { selected } = this.state;

        return (
            <span>
                <Button
                    name='Javascript'
                    onClick={() => this._onClick('js')}
                    selected={selected === 'js'}
                />
                {this._generateTabsAndDropdown()}
            </span>);
    }

    _generateTabsAndDropdown = () => {
        const { commonScriptsCode } = this.props.snippets;
        const { selected } = this.state;

        if (!this.state.hideTabs) {
            if (commonScriptsCode.length > 4) {
                let tabs = [];
                let leftoverScripts = [];

                for (let i = 0; i <= 4; i++) {
                    tabs[i] = <Button
                        key={commonScriptsCode[i].name}
                        name={commonScriptsCode[i].name}
                        onClick={() => this._onClick(commonScriptsCode[i].name)}
                        selected={selected === commonScriptsCode[i].name} 
                    />;
                }

                for (let i = 5; i < commonScriptsCode.length; i++) {
                    leftoverScripts[i-4] = commonScriptsCode[i];
                }

                return [tabs, this._renderDropdown(leftoverScripts)];

            } else {
                return commonScriptsCode.map(jsScript =>
                    <Button
                        key={jsScript.name}
                        name={jsScript.name}
                        onClick={() => this._onClick(jsScript.name)}
                        selected={selected === jsScript.name} 
                    />);
            }
        } else {
            if (commonScriptsCode.length) {
                return this._renderDropdown(commonScriptsCode);
            }
        }
    }

    //this method checks whether chosen snippet is among the dropdown items
    _checkIfInside(scripts) {
        const { selected } = this.state;

        for (let i in scripts) {
            if (selected === scripts[i].name) {
                return true;
            }
        }

        return false;
    }
    
    _renderDropdown = (scripts) => {
        const { selected } = this.state;

        return <Dropdown
            name={selected === 'js' || selected === 'html' ? 'Javascript' : selected}
            selected={this._checkIfInside(scripts)}
            key='dropdown'
        >
            {scripts.map(jsScript =>
                <DropdownItem
                    key={jsScript.name}
                    name={jsScript.name}
                    onClick={() => this._onClick(jsScript.name)}
                    selected={selected}  
                />
            )}
        </Dropdown>;
    }

    _renderScript = () => {
        const { selected } = this.state;
        const { snippets } = this.props;

        if (selected === 'html') {
            return <div>
                <div className="file-name">HTML + Javascript</div>
                <pre className='prettyprint lang-html line-numbers source-code'>
                    <code id='snippet-selected' className='language-html'>{snippets.html}</code>
                </pre>
            </div>;
        }

        return <div>
            <div className="file-name">{selected === 'js' ? 'Javascript' : this._getCustomScriptName()}</div>
            <pre className='prettyprint lang-js line-numbers source-code'>
                <code id='snippet-selected' className='language-js'>
                    {selected === 'js' ? snippets.code : this._getCustomScriptSource()}
                </code>
            </pre>
        </div>;

    }

    render() {
        return (
            <div className='snippets'>
                <div className='info-box'>
                    <div className='lightbulb-icon'><BulbIcon/></div>
                    <div className='text'>
                        To run this example locally, please clone the <a
                            href='https://github.com/tomtom-international/maps-sdk-for-web-examples/tree/master/V6'
                            target='_blank' rel='noopener noreferrer' >Github project</a> and follow the instructions
                        in <a href='https://github.com/tomtom-international/maps-sdk-for-web-examples/blob/master/V6/README.md'
                            target='_blank' rel='noopener noreferrer'>README</a>. If you prefer to copy example code manually into
                        your project, please make sure that you copied and included all files shown in the code listings presented
                        on this page.
                    </div>
                </div>
                <div className='code-menu'>
                    <Button
                        name='HTML + Javascript'
                        onClick={() => this._onClick('html')}
                        selected={this.state.selected === 'html'}
                    />
                    {this._renderScriptMenuItem()}
                </div>

                <div className='snippet'>
                    <div className='snippet__content'>
                        {this._renderScript()}
                    </div>
                </div>
            </div>
        );
    }
}

Snippets.propTypes = {
    snippets: PropTypes.object.isRequired
};
